/**
 * LoadingSkeleton - Skeleton de carregamento para PendingDomainsPanel
 */
import React from 'react';
import {
    Box,
    CircularProgress,
    Typography
} from '@mui/material';
import { useTheme as useMuiTheme } from '@mui/material/styles';

const LoadingSkeleton = () => {
    const theme = useMuiTheme();

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', p: 4 }}>
            <CircularProgress size={48} thickness={4} sx={{ color: 'primary.main', mb: 3 }} />
            <Typography variant="h6" color="text.primary" fontWeight={600} mb={1}>
                Carregando Domínios Pendentes
            </Typography>
            <Typography variant="body2" color="text.secondary">
                Prepadando fila de análise e métricas HypeStat...
            </Typography>
        </Box>
    );
};

export default LoadingSkeleton;
